import React, { Component, Fragment } from 'react'
import { Link }             from "react-router-dom"
import { withRouter }       from "react-router"
//ELEM REACT16 CHANGE
import { Button, Icon, Modal, Progress,  StepTitle,
    StepGroup,
    StepDescription,
    StepContent,
    Step, } from "semantic-ui-react";
import Responsive from "react-responsive"

@withRouter
class ReturnPageProgress extends Component {

    render() {
        const {referer, isRequest, activeStep = 0, progress} = this.props
        return (
        <Fragment>
        <Responsive minWidth={790} >
            <div className="tc">
            <StepGroup ordered>
                <Step completed={progress >= 1} active={progress < 1}>
                <StepContent>
                <StepTitle>Markt bestätigen</StepTitle>
                <StepDescription>Bestätigen Sie Ihre Marktdetails</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 2} active={progress === 1}>
                <StepContent>
                <StepTitle>Restantenerfassung</StepTitle>
                <StepDescription>Erfassung der Restanten</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 3} active={progress === 2}>
                <StepContent>
                <StepTitle>Kontaktdaten</StepTitle>
                <StepDescription>Geben Sie Ihre Kontaktdaten ein</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 4} active={progress === 3}>
                <StepContent>
                <StepTitle>Bestätigung</StepTitle>
                <StepDescription>Überprüfung Ihrer Daten</StepDescription>
                </StepContent>
                </Step>
            </StepGroup>
         </div>
        </Responsive>

        <Responsive maxWidth={789} >
        <div>
            <div className="ui top attached steps">
            {progress <= 1 && <div className={progress >= 1 ? "completed step" : (progress < 1 ? "active step" : "step")}><i aria-hidden="true" className="id badge icon"></i>
            <div className="content">
                <div className="title">Markt bestätigen 1 / 4</div>
                <div className="description">Bestätigen Sie Ihre Marktdetails</div>
                </div>
            </div>}
            {progress >= 2 && <div className={progress >= 2 ? "completed step" : (progress === 1 ? "active step" : "step")}><i aria-hidden="true" className="truck icon"></i>
                <div className="content">
                <div className="title">Restantenerfassung 2 / 4</div>
                <div className="description">Erfassung der Restanten</div>
                </div>
            </div>}
            {progress >= 3 && <div className={progress >= 3 ? "completed step" : (progress === 2 ? "active step" : "step")}><i aria-hidden="true" className="address card icon"></i>
                <div className="content">
                <div className="title">Kontaktdaten 3 / 4</div>
                <div className="description">Geben Sie Ihre Kontaktdaten ein</div>
                </div>
            </div>}
            {progress >= 4 && <div className={progress >= 4 ? "completed step" : (progress === 3 ? "active step" : "step")}><i aria-hidden="true" className="info circle icon"></i>
                <div className="content">
                <div className="title">Bestätigung 4 / 4</div>
                <div className="description">Überprüfung Ihrer Daten</div>
                </div>
            </div>}
            </div>
            </div>
        </Responsive>

        </Fragment>
        )
    }
}

export default ReturnPageProgress;


// WEBPACK FOOTER //
// ./src/theme/lindt/pages/returnCheckout/ReturnPageProgress.js